var TESNAV = TESNAV || {};

TESNAV.menuToggle = function() {

// change menu items (only on mobile, otherwise allow link to reload page)
  TESNAV.$container.on('click', '.js-nav-menu-item', function (e) {

    if (TES.viewportWidth.small.down()) {
      var $container,
        $trigger = jQuery(this),
        offsetTop = $trigger.offset().top;

      $container = $trigger.closest('.js-nav-menu-items');

      // activate button & associated submenus
      $trigger
        .add($container.find($trigger.attr('data-target')))
        .toggleClass('active');

      // deactivate other buttons & associated submenus
      $container
        .find('.js-nav-menu-item')
        .not($trigger)
        .each(function () {
          var $that = jQuery(this);
          $that.removeClass('active');
          $container.find($that.attr('data-target')).removeClass('active');
        });

      /* if submenus above the clicked item are now closed, it may have scrolled off screen.
      So scroll the document to bring it back into view.
       */
      if ($trigger.offset().top !== offsetTop) {
        jQuery(document).scrollTop($trigger.offset().top - offsetTop);
      }

      /* this event could be picked up by other components, eg. to crop document height to the new
      popup height */
      $container.trigger('heightChange');

      e.preventDefault();
    }

  });
};
